module.exports = __webpack_public_path__ + "img/normal-big.296402a1.svg";